// extracted by mini-css-extract-plugin
module.exports = {"container":"AH7AVJn0vNzY-7lHJv0AM","icon":"_3uCPwmPE0d8yJaPS8qdgq3","cta":"_1iEm0BKbIiQTgJpgUIHCtv","tnc-text":"_2hIMW-lnXRcWg2KJH107N3"};